import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  rangeContainer: {
    boxShadow: theme.shadows[20],
  },
  applyButton: {
    color: theme.palette.grey[800],
  },
  iconRight: {
    transform: 'rotate(-90deg)',
    position: 'absolute',
    right: '15px',
    background: '#fff',
  },
  iconLeft: {
    transform: 'rotate(90deg)',
    position: 'absolute',
    left: '15px',
  },
  activeBorder: {
    border: "3px solid #FFCC11"
  },
  dateBlock: {
    padding: '5px',
    margin: '5px',
    borderRadius: '7px',
    '& legend': { cursor: 'pointer'}
    // backgroundColor: "lightgrey",
    // boxShadow: " 10px 5px 5px black"

  }
}));
